import { API_ORIGIN } from "../Utils";
import { capturePartnerEvent } from "./analytics";

/** Same routing rule as AuthenticationMiddleware after login. */
export async function navigateToUserApp(source = "partner_dashboard") {
  capturePartnerEvent("partner_use_as_user_clicked", { source });

  const token = localStorage.getItem("accessToken");
  const headers = token ? { authorization: `Bearer ${token}` } : {};

  let target = "/formats-dashboard/";

  try {
    const res = await fetch(`${API_ORIGIN}/mnfapp/currentuser/`, { headers });
    if (res.ok) {
      const data = await res.json();
      const projectCount = data?.project_count ?? 0;
      target = projectCount > 0 ? "/formats-dashboard/" : "/scriptpad/create-project";
    }
  } catch {
    /* fall back to formats-dashboard */
  }

  window.location.href = target;
}
